import { Alert, AlertTitle } from "@mui/material"
import type { ReactElement } from "react"

const PermissionDeniedAlert = ({
  title = "Permission Denied",
  message = "Please contact the administrator to grant the necessary permissions.",
}: {
  title?: string
  message?: string
}): ReactElement => (
  <Alert severity='warning' variant='filled' color='warning'>
    <AlertTitle>{title}</AlertTitle>
    {message}
  </Alert>
)

export default PermissionDeniedAlert
